export enum RagIndex {
  NAW = 5050,
  LiaisonsNotarie = 2097,
  LamylineNew = 2098,
  LamylineNotarie = 2099,
  ECAY = 6002,
  CissContable = 6003,
  CissFiscal = 6004,
  CissLaboral = 6005
}

export const IndexIdentifiers: Record<RagIndex, string> = {
  [RagIndex.NAW]: 'Soluciones Aranzadi',
  [RagIndex.LiaisonsNotarie]: 'Liaisons Sociales',
  [RagIndex.LamylineNew]: 'Lamyline New',
  [RagIndex.LamylineNotarie]: 'Lamyline Notaire',
  [RagIndex.ECAY]: 'El Consultor de los ayuntamientos',
  [RagIndex.CissContable]: 'CISS Contable',
  [RagIndex.CissFiscal]: 'CISS Fiscal',
  [RagIndex.CissLaboral]: 'CISS Laboral'
};
